<template>
  <div class="box">
    <Header title="访问出错啦！"></Header>
    <!-- <van-icon class="err-icon" name="failure" /> -->
    <div class="err-info">
      <div class="err-status" v-text="errStatus"></div>
      <div class="err-message" v-text="errMessage"></div>
    </div>
    <img class="err-img" src="../assets/images/error.png" alt="">
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "ihuberr",
  data() {
    return {
      errStatus: this.$route.params.status,
      errMessage: this.$route.params.message
    };
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  background-image: linear-gradient(to bottom right, #eeeeee, #ffffff, #eeeeee);
  .err-icon {
    margin-top: 100px;
    font-size: 120px;
    color: gray;
  }
  .err-info {
    margin-top: 20px;
    padding: 20px;
    font-size: 20px;
    color: #323233;
  }
  .err-img {
    width: 100%;
  }
}
</style>